import { render } from "./ModalEditNote.vue?vue&type=template&id=0389db3a&scoped=true"
import script from "./ModalEditNote.vue?vue&type=script&lang=js"
export * from "./ModalEditNote.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0389db3a"

export default script